export interface ValueSetDetail {
    valueSetName: string;
    valueSetDesc: string;
    valueSetType: 'STATIC' | 'DYNAMIC';
    attributeList: string[];
    dynamicSqlText: string | null;
    categoryName: 'Facility' | 'Global';
}

export const INITIAL_VALUE_SETS: ValueSetDetail[] = [
    {
        valueSetName: 'AdditionalProcedures',
        valueSetDesc: 'Additional Procedures',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'AnesthesiaASAProcedureCodes',
        valueSetDesc: 'Anesthesia ASA Procedure Codes',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT', 'Service|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'Comorbidities',
        valueSetDesc: 'Comorbidities',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'Neuraxial',
        valueSetDesc: 'Neuraxial',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'RegionalBlocks',
        valueSetDesc: 'Regional Blocks',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'RegionalMeds',
        valueSetDesc: 'Regional Meds',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT', 'TrackWastage|BOOLEAN'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'SecondaryProcedures',
        valueSetDesc: 'Secondary Procedures',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'SurgeryLocations',
        valueSetDesc: 'Surgery Locations',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'SurgicalDiagnoses',
        valueSetDesc: 'Surgical Diagnoses',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT', 'Service|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
    {
        valueSetName: 'SurgicalProcedures',
        valueSetDesc: 'Surgical Procedures',
        valueSetType: 'STATIC',
        attributeList: ['Code|VARCHAR', 'Description|TEXT', 'Service|TEXT'],
        dynamicSqlText: null,
        categoryName: 'Facility',
    },
];
